import config from "../config/config";
import { useContext } from 'react';
import { TeamsFxContext } from '../components/Context';
import { useApiMutation } from "./useApiMutation";
import { logger } from "../Logger";
import { MethodType } from "../types/ApiRequest";

/**
 * Get the next lov set for the LOV.
 */
export const useGetNextLov = () => {
  const teamsContext = useContext(TeamsFxContext);

  const mutation = useApiMutation<any, any>({
    url: `${config.tcTeamsWebApiUrl}/getnextlovvalues`,
    method: MethodType.POST,
    key: 'getNextLov',
    enabled: teamsContext.teamcenter.isAuthenticated && !teamsContext.teamcenter.isAuthenticating,
    action: 'useGetNextLov'
  }, logger);

  return mutation;
};
